import { RouteConfig } from 'vue-router';

import List from './views/List.vue';
import Form from './views/Form.vue';

export default [
  // list
  {
    name: 'systemconfiguration',
    path: '',
    component: List,
    meta: {
      hideMenu: true,
    },
  },
  // edit
  {
    path: ':key',
    component: Form,
    meta: {
      hideMenu: true,
      hideTab: true,
    },
  },
] as RouteConfig[];
